import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import Chip from '@material-ui/core/Chip';

const styles = theme => ({
    root: {
        display: 'flex',
        justifyContent: 'left',
        flexWrap: 'wrap',
    },
    chip: {
        marginRight: "3px",
        marginBottom: theme.spacing.unit,
    },
})

class Filter extends React.Component {

    render() {

        const { classes, data, active, replaceByKeys } = this.props;

        return (
            <div className={classes.root}>
            <Chip button onClick={() => this.props.filter("reset")} label={"Alle"} className={classes.chip} variant="outlined" />
                {data.map((item) => {
                    var value = item.value
                    var key = value
                    if(replaceByKeys && replaceByKeys[value]) {
                        value = replaceByKeys[value]
                    }
                    return <Chip color={(active && active[item.key] && active[item.key] === key) ? "primary" : ""} button onClick={() => this.props.filter(item.key, key)} label={value} className={classes.chip} />
                }
                )}
            </div>
        )
    }

}

export default withStyles(styles)(Filter);



// WEBPACK FOOTER //
// ./src/Components/Filter.js